import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    margin-left: -8px;
    .default {
        width: 100%;
        display: flex;
        background-color: #faf8f8;
        position: sticky;
        position: -webkit-sticky;
        margin-top: 8px;
        top: 0;
        left: 0;
        margin-left: -10px;

        @media (max-width: 930px) {
                margin-top: 0;
                height: 65px;
                background-color: #fff;
                border-bottom: 1px solid #e7e7e7;
                align-items: center;
                justify-content: center;
            }
            .close {
                display: none;

                @media(max-width: 930px) {
                        display: flex;
                        position: absolute;
                        right: 8px;
                    }
                
                button {
                    background-color: transparent;
                    outline: none;
                    cursor: pointer;
                    border: none;
                    align-self: center;
                    box-sizing: border-box;

                    .i-close {
                        vertical-align: middle;
                        align-self: center;
                        font-size: 36px;
                        top: 10px;
                        bottom: 10px;
                        left: 10px;
                        right: 10px;
                        color: #c0b7b8 !important;

                        @media(max-width: 930px) {
                            font-size: 22px;
                        }
                    }
                }
            }
        label {
            padding: 8px;
            padding-left: 18px;
            color: #a49a9b;
            font-size: 16px;
            font-weight: 400;
            font-family: Montserrat;

            @media (max-width: 930px) {
                padding: 0;
                padding-left: 0;
                color: #000000;
                font-weight: bold;
            }
        }
    }

    .horario-disponivel {
        cursor: pointer;
        width: 100%;
        display: flex;
        background-color: #fff;
        top: 0;
        left: 0;

        @media (max-width: 930px) {
                align-items: center;
                justify-content: center
            }

        :hover {
            background-color: #faf8f8;
        }

        :active {
            background-color: #dedede
        }

        .disponivel {
            cursor: pointer;
            padding: 10px;
            padding-left: 18px;
            color: #382325;
            font-size: 16px;
            font-weight: 500;
            font-family: Montserrat;

            @media (max-width: 930px) {
                font-size: 20px;
                padding: 18px;
                padding-left: 0;
                padding-right: 0;
            }
        }
    }

    .horario-indisponivel {
        cursor: default;
        width: 100%;
        display: flex;
        background-color: #fff;
        top: 0;
        left: 0;

        @media (max-width: 930px) {
                align-items: center;
                justify-content: center
            }

        .disponivel {
            cursor: default;
            padding: 10px;
            padding-left: 18px;
            color: #a9a1a1;
            font-size: 16px;
            font-weight: 400;
            font-family: Montserrat;

            @media (max-width: 930px) {
                font-size: 20px;
                padding: 18px;
                padding-left: 0;
                padding-right: 0;
            }
        }
    }
`